module.exports = __webpack_public_path__ + "static/company_address_2-8c69b76b61f29290a1a63f7e02638412.png";